import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { z } from "zod";
import { LoginForm } from "@/components/auth/login-form";
import { useAuth } from "@/services/auth/auth-context";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({ from: z.string().optional().default("/") }),
  component: () => {
    const { authUser, userId } = useAuth();
    const { from } = Route.useSearch();
    const navigate = useNavigate();

    // if the user is authenticated, route them back to where they came
    useEffect(() => {
      // checks to see if the user is a client and redirect to the client dashboard.
      // this prevents the issue of a new client signing up and not creating a client model in the database
      const userIsClient = async () => {
        if (authUser) {
          if (userId) {
            navigate({ to: "/clientdashboard", replace: true });
          } else {
            navigate({ to: from, replace: true });
          }
        }
      };
      userIsClient();
    }, [authUser, navigate, from]);

    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
          <LoginForm />
        </div>
      </div>
    );
  },
});
